import React from 'react';

import { ButtonInnerWithLoadingState } from '../ButtonInner/ButtonInnerWithLoadingState';
import type { OutlineButtonProps } from './types';
import { buttonSize } from '../styles/buttonSizes.styles';
import * as styles from './OutlineButton.styles';

/** @deprecated Use design-system-core-components' Button instead **/
export const OutlineButton = ({
  active,
  children,
  compact = false,
  fullWidth = false,
  loading = false,
  textColorMode = 'brand',
  ...props
}: OutlineButtonProps) => (
  <button
    css={[styles.outlineButton, buttonSize(compact, fullWidth)]}
    data-is-active={active}
    {...props}
  >
    <ButtonInnerWithLoadingState compact={compact} loading={loading} textColorMode={textColorMode}>
      {children}
    </ButtonInnerWithLoadingState>
  </button>
);
